// App
export const SET_ACTIVE_DEVICE = 'SET_ACTIVE_DEVICE';
export const HIGHLIGHT = 'HIGHLIGHT';
export const REMOVE = 'REMOVE';
export const PREVIEW = 'PREVIEW';

// Container
export const INSERT_ROW = 'INSERT_ROW';
export const SET_CONTAINER_FULL_WIDTH_OPTION = 'SET_CONTAINER_FULL_WIDTH_OPTION';
export const SET_CONTAINER_FIXED_OPTION = 'SET_CONTAINER_FIXED_OPTION';

// Row
export const RESIZE_COLUMN = 'RESIZE_COLUMN';
export const RESIZE_COLUMN_FINISHED = 'RESIZE_COLUMN_FINISHED';
export const SET_ROW_NUMBER_OF_COLUMNS = 'SET_ROW_NUMBER_OF_COLUMNS';
export const SET_ROW_PADDING = 'SET_ROW_PADDING';
export const SET_ROW_MARGIN = 'SET_ROW_MARGIN';

// Column
export const INSERT_ELEMENT_INTO_COLUMN = 'INSERT_ELEMENT_INTO_COLUMN';
export const REMOVE_ELEMENT_FROM_COLUMN = 'REMOVE_ELEMENT_FROM_COLUMN';

export const SET_DROP_PREVIEW_INDEX_PATH = 'SET_DROP_PREVIEW_INDEX_PATH';
export const RESET_DROP_PREVIEW_INDEX_PATH = 'RESET_DROP_PREVIEW_INDEX_PATH';
export const REINDEX_ELEMENTS = 'REINDEX_ELEMENTS';

export const SET_COLUMN_BACKGROUND_COLOR = 'SET_COLUMN_BACKGROUND_COLOR';
export const SET_COLUMN_PADDING = 'SET_COLUMN_PADDING';

// Button Element
export const SET_BUTTON_ELEMENT_TEXT = 'SET_BUTTON_ELEMENT_TEXT';
export const SET_BUTTON_ELEMENT_URL = 'SET_BUTTON_ELEMENT_URL';
export const SET_BUTTON_ELEMENT_TARGET = 'SET_BUTTON_ELEMENT_TARGET';
export const SET_BUTTON_ELEMENT_CORNER_RADIUS = 'SET_BUTTON_ELEMENT_CORNER_RADIUS';
export const SET_BUTTON_ELEMENT_WIDTH = 'SET_BUTTON_ELEMENT_WIDTH';
export const SET_BUTTON_ELEMENT_PADDING = 'SET_BUTTON_ELEMENT_PADDING';

// Image Element
export const SET_IMAGE_ELEMENT_FILE_INFO = 'SET_IMAGE_ELEMENT_FILE_INFO';
export const SET_IMAGE_ELEMENT_URL = 'SET_IMAGE_ELEMENT_URL';
export const SET_IMAGE_ELEMENT_WIDTH = 'SET_IMAGE_ELEMENT_WIDTH';
export const SET_IMAGE_ELEMENT_HEIGHT = 'SET_IMAGE_ELEMENT_HEIGHT';
export const SET_IMAGE_ELEMENT_ALIGN = 'SET_IMAGE_ELEMENT_ALIGN';

// Search Element
export const SET_SEARCH_TEXT_WIDTH = 'SET_SEARCH_TEXT_WIDTH';
export const SET_SEARCH_VERTICAL_PADDING = 'SET_SEARCH_VERTICAL_PADDING';
export const SET_SEARCH_TEXT_BG_COLOR = 'SET_SEARCH_TEXT_BG_COLOR';
export const SET_SEARCH_TEXT_COLOR = 'SET_SEARCH_TEXT_COLOR';
export const SET_SEARCH_BORDER_COLOR = 'SET_SEARCH_BORDER_COLOR';
export const SET_SEARCH_BUTTON_STYLE = 'SET_SEARCH_BUTTON_STYLE';
export const SET_SEARCH_BUTTON_BG_COLOR = 'SET_SEARCH_BUTTON_BG_COLOR';
export const SET_SEARCH_BUTTON_TEXT_ICON_COLOR = 'SET_SEARCH_BUTTON_TEXT_ICON_COLOR';
export const SET_SEARCH_BUTTON_CONTENT = 'SET_SEARCH_BUTTON_CONTENT';
export const SET_SEARCH_ICON_COLOR = 'SET_SEARCH_ICON_COLOR';
export const SET_SEARCH_PLACEHOLDER_TEXT = 'SET_SEARCH_PLACEHOLDER_TEXT';

// Language Selector Element
export const LANGUAGE_SELECTOR_SELECT = 'LANGUAGE_SELECTOR_SELECT';
export const LANGUAGE_SELECTOR_MOVE_UP = 'LANGUAGE_SELECTOR_MOVE_UP';
export const LANGUAGE_SELECTOR_MOVE_DOWN = 'LANGUAGE_SELECTOR_MOVE_DOWN';
export const LANGUAGE_SELECTOR_REMOVE = 'LANGUAGE_SELECTOR_REMOVE';
export const LANGUAGE_SELECTOR_SAVE = 'LANGUAGE_SELECTOR_SAVE';
export const LANGUAGE_SELECTOR_ENABLE_FLAG = 'LANGUAGE_SELECTOR_ENABLE_FLAG';

// Shopping Icon Element
export const SET_SHOPPING_ICON_ELEMENT_FILE_INFO = 'SET_SHOPPING_ICON_ELEMENT_FILE_INFO';
export const SET_SHOPPING_ICON_ELEMENT_ICON_SIZE = 'SET_SHOPPING_ICON_ELEMENT_ICON_SIZE';
export const SET_SHOPPING_ICON_ELEMENT_ICON_COLOR = 'SET_SHOPPING_ICON_ELEMENT_ICON_COLOR';
export const SET_SHOPPING_ICON_ELEMENT_TEXT_COLOR = 'SET_SHOPPING_ICON_ELEMENT_TEXT_COLOR';

// Navigation Element
export const SET_NAVIGATION_MENU = 'SET_NAVIGATION_MENU';
export const SET_NAVIGATION_STYLE = 'SET_NAVIGATION_STYLE';
export const SET_NAVIGATION_TEXT_COLOR = 'SET_NAVIGATION_TEXT_COLOR';
export const SET_NAVIGATION_TEXT_HOVER_COLOR = 'SET_NAVIGATION_TEXT_HOVER_COLOR';
export const SET_NAVIGATION_ACCENT_COLOR = 'SET_NAVIGATION_ACCENT_COLOR';

// Social Media Element
export const SOCIAL_MEDIA_SELECT = 'SOCIAL_MEDIA_SELECT';
export const SOCIAL_MEDIA_MOVE_UP = 'SOCIAL_MEDIA_MOVE_UP';
export const SOCIAL_MEDIA_MOVE_DOWN = 'SOCIAL_MEDIA_MOVE_DOWN';
export const SOCIAL_MEDIA_REMOVE = 'SOCIAL_MEDIA_REMOVE';
export const SOCIAL_MEDIA_SAVE = 'SOCIAL_MEDIA_SAVE';
export const SOCIAL_MEDIA_CHANGE_COLOR = 'SOCIAL_MEDIA_CHANGE_COLOR';
export const SOCIAL_MEDIA_CHANGE_HOVER_COLOR = 'SOCIAL_MEDIA_CHANGE_HOVER_COLOR';
export const SOCIAL_MEDIA_CHANGE_ICON_SIZE = 'SOCIAL_MEDIA_CHANGE_ICON_SIZE';

// Divider Element
export const DIVIDER_CHANGE_COLOR = 'DIVIDER_CHANGE_COLOR';
export const DIVIDER_CHANGE_WIDTH = 'DIVIDER_CHANGE_WIDTH';
export const DIVIDER_CHANGE_VERTICAL_PADDING = 'DIVIDER_CHANGE_VERTICAL_PADDING';

// TextBox Element
export const TEXTBOX_CHANGE_TEXT = 'TEXTBOX_CHANGE_TEXT';

// Logo Element
export const SET_LOGO_ELEMENT_WIDTH = 'SET_LOGO_ELEMENT_WIDTH';
export const SET_LOGO_ELEMENT_HEIGHT = 'SET_LOGO_ELEMENT_HEIGHT';
export const SET_LOGO_ELEMENT_LINK_HOMEPAGE = 'SET_LOGO_ELEMENT_LINK_HOMEPAGE';
export const SET_LOGO_ELEMENT_MARGIN = 'SET_LOGO_ELEMENT_MARGIN';
export const SET_LOGO_ELEMENT_PADDING = 'SET_LOGO_ELEMENT_PADDING';


// WEBPACK FOOTER //
// ./app/header-builder/actions/action-names.js